/**
 * Grows textareas to fit their content where `field-sizing` is unsupported.
 */
( function() {
	if ( window.CSS && CSS.supports && CSS.supports( 'field-sizing', 'content' ) ) {
		return;
	}

	const areas = document.querySelectorAll( '.form-field textarea' );

	if ( ! areas.length ) {
		return;
	}

	/**
	 * Match the box to its contents.
	 *
	 * @param {HTMLTextAreaElement} area The field to size.
	 */
	function fit( area ) {
		area.style.height = 'auto';
		area.style.height = area.scrollHeight + 'px';
	}

	areas.forEach( function( area ) {
		area.removeAttribute( 'rows' );

		fit( area );
		area.addEventListener( 'input', function() {
			fit( area );
		} );
	} );
}() );
